import "./bootstrap.js";
import "../css/app.css";

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import PrimeVue from "primevue/config";
//import "primevue/resources/themes/lara-light-indigo/theme.css";
import "primevue/resources/themes/aura-light-noir/theme.css";
import ToastService from "primevue/toastservice";
import { InertiaProgress } from "@inertiajs/progress";
import ConfirmationService from "primevue/confirmationservice";
import FocusTrap from "primevue/focustrap";
import Tooltip from "primevue/tooltip";
import "primeicons/primeicons.css";
import assetsMixin from "./assets.js";
import il8n from "./il8n.js";

createInertiaApp({
  resolve: (name) => require(`./Pages/${name}`),

  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) });
    app
      .use(plugin)
      .use(PrimeVue)
      .use(ToastService)
      .use(ConfirmationService)
      .use(il8n)
      .mixin(assetsMixin)
      .mount(el);

    app.directive("focustrap", FocusTrap);
    app.directive("tooltip", Tooltip);

    return app;
  },
});

InertiaProgress.init({
  color: "#4B5563",
  delay: 250,
  includeCSS: true,
  showSpinner: true,
});
